/** temporary redirect to go to non-React pages */
export const hardRedirect = (url: string): void => {
  window.location.href = url;
};

/** See TP-28516 "XSS Security Vulnerability".
The following script "window.location.href = alert(123)" will show allert modal. 
And this is vulnerable beause instead of allert there could be a script that redirects user to a fishing site.
Should use safeRedirect when getting redirect url from the window.location.search, 
or when getting url from any other place where user can change it somehow.
When use safeRedirect - redirecting will be handled in Backend. */
export const safeRedirect = (url: string): void => {
  window.location.href = `/Redirect/To?url=${window.btoa(url)}`;
};
